"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractPackage = void 0;
var lodash_1 = require("lodash");
var AbstractPackage = /** @class */function () {
  function AbstractPackage() {
    /** Отметка времени */
    this.timestamp = Date.now();
  }
  AbstractPackage.createInstance = function (values) {
    var instance = new this();
    instance.applyValues(values);
    return instance;
  };
  /**
   * Выполнить апгрейд данных пакета до самой свежей версии пакета
   *
   * Этот метод нужен на случай внесения изменений в ранее сформированный пакет
   * с целью уменьшения количества сопровождающего кода.
   *
   * Это позволит держать актуальным только одну версию сопровождающего кода,
   * который будет работать только с актуальной версией пакета.
   *
   * Вместо изменеия пакета
   * 1 можно старый пометить как "устаревший" и сделатиь новый. В реальности
   * .  это как если растроргнуть договор и заключить новый.
   * 2 сделать инкрементальный пакет, включающий изменения.  В реальности
   * .  это как подписать дополнительное соглашение к ранее подписанному
   * .  договору
   */
  AbstractPackage.prototype.upgrage = function () {
    throw new Error("'".concat(this.constructor.name, ".upgrade()' not implemented"));
  };
  AbstractPackage.prototype.applyValues = function (values) {
    var properties = this.getClassProperties();
    (0, lodash_1.assign)(this, (0, lodash_1.pick)(values, properties));
  };
  AbstractPackage.prototype.getClassProperties = function () {
    return ['package', 'timestamp'];
  };
  return AbstractPackage;
}();
exports.AbstractPackage = AbstractPackage;
